<template>
    <div>
        <el-row :gutter="20" style="border: 1px solid #e2e7ed">

            <el-col>

                <div class="tip" style="padding: 35px 35px 21px 35px;display: flex">
                    <slot name="main"></slot>
                    <div>
                        <upload-document buttonName="Agregar Documento"
                                         :type="3"
                                         @fileInfo="addFileToRequest"/>
                    </div>
                </div>

                <el-table :data="filterSection(model)" size="small" style="width: 100%">
                    <el-table-column
                        label="Nombre de archivo"
                        min-width="200px">
                        <template slot-scope="scope">
                            {{ scope.row.fileName ? scope.row.fileName : '' }}
                            <span v-if="scope.row.file">
                              {{ scope.row.file.fileName }}
                         </span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="Descripción"
                        min-width="200px">
                        <template slot-scope="scope">
                            <el-form
                                size="small"
                                @submit.native.prevent
                                ref="docs"
                                :model="scope"
                                status-icon>
                                <el-form-item prop="row.description"
                                              :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'change' },
                                        { pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/, message: 'Ingrese sólo letras minúsculas' }]">
                                    <el-input v-model="scope.row.description"
                                              v-my-only-alphanumeric="{maxChars: 500}"
                                              :maxlength="500"
                                              v-if="scope.row.id"
                                              :disabled="onlyRead == true ? true: false"
                                              placeholder="">
                                    </el-input>
                                    <el-input v-model="scope.row.description"
                                              :maxlength="500"
                                              v-my-only-alphanumeric="{maxChars: 500}"
                                              v-if="!scope.row.id"
                                              placeholder="">
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column label="Documento requerido"
                                     min-width="200px"
                                     v-if="userRequest.isPreregister">
                        <template slot-scope="scope">
                            <el-select
                                v-model="scope.row.cat_requirement_document_id"
                                filterable
                                @change="disabledRequirement(scope.row.cat_requirement_document_id)"
                                placeholder="Seleccionar"
                                style="width: 100%">
                                <el-option
                                    v-for="item in requirements"
                                    :key="item.id"
                                    :disabled="!item.isActive"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>

                        </template>

                    </el-table-column>
                    <el-table-column label="Opciones de edición" align="center" min-width="160">
                        <template slot-scope="scope">
                            <div>
                                <el-button-group>
                                    <el-tooltip
                                        v-if="scope.row.file_id"
                                        class="item"
                                        effect="dark"
                                        content="Ver documento"
                                        placement="top-end">
                                        <el-button
                                            size="small"
                                            icon="el-icon-view"
                                            @click="showPdf(scope.row)">
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip
                                        class="item"
                                        effect="dark"
                                        v-loading="showLoading"
                                        content="Eliminar documento"
                                        placement="top-end">
                                        <el-button
                                            size="small"
                                            type="danger"
                                            @click="removeDocument(scope.row)">
                                            <i class="fas fa-trash"></i>
                                        </el-button>
                                    </el-tooltip>
                                </el-button-group>
                            </div>
                        </template>

                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <ShowDocuments :closeShowDocument="closeShowDocument"
                       :type="1"
                       :activeShowDocument="activeShowDocument"
                       :fileNameHash="fileNameHash"
                       v-if="activeShowDocument"/>

        <el-dialog title="Solicitud Alta de Usuario"
                   :visible.sync="showDocument"
                   :close-on-press-escape="true"
                   :close-on-click-modal="true">
            <el-row>
                <span v-if="!photoUrl"
                      slot="title" class="dialog__title" style="color: #fff;">
                    <p style="color:white">
                        Cargando documento, por favor espere...
                    </p>
                    <br>
                    <div v-loading="!photoUrl"></div>
                </span>
                <span v-if="photoUrl" slot="title" class="dialog__title" style="color: #fff;">
                    <el-row>
                        <el-col>
                            Documento
                            <div style="position: absolute;bottom: -2px;right: 104px;">
                            <el-button type="info" plain @click="downloadPdf">
                                <i class="fas fa-cloud-download-alt"></i>&nbsp;Descargar
                            </el-button>
                            </div>
                        </el-col>
                    </el-row>
                </span>
                <div v-if="photoUrl" style="background: #494a4cd1">
                    <el-row>
                        <el-col>
                            <div style="width: 100%;height: 100vh;margin-left: auto;margin-right: auto">
                                <object v-if="photoUrl"
                                        :data="photoUrl"
                                        width="100%" height="100%">
                                    <p>
                                        Su navegador no soporta la vista de preview en línea, por favor descargue el
                                        archivo
                                        para visualizar.
                                    </p>
                                </object>
                            </div>

                        </el-col>
                    </el-row>
                </div>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import UploadDocument from '@/components/partials/UploadDocument';
import ShowDocuments from '@/components/partials/ShowDocuments';

export default {

    components: {
        UploadDocument,
        ShowDocuments
    },
    props: {
        sectionId: {},
        onlyRead: {},
        onlyOne: {
            type: Boolean
        },

        isPreregister: {},

        userId: {},

        requirements: {}
    },
    data() {
        return {
            item: null,
            fileData: {},
            fileNameHash: null,
            activeShowDocument: false,
            disabledButton: false,
            showDocument: false,
            photoUrl: null,
            showLoading: false
        }
    },
    mounted() {
        this.init()

    },


    computed: {
        userInfo() {
            return this.$store.state.user.user;
        },

        onlyOneAlias() {
            return this.onlyOne && this.onlyOne === true ? true : false;
        },
        model() {
            return this.userRequest && this.userRequest.documents ? this.userRequest.documents : [];
        },

        isPreregisterAlias() {
            return this.isPreregister
        },

        ...mapGetters('utils', {
            userRequest: "userRequest",
        }),
    },
    methods: {
        ...mapActions('utils', {
            fetchSigle: "fetchSigle",
        }),
        ...mapMutations('utils', {
            addUserDoc: "addUserDoc",
            removePublicDocument: "removePublicDocument"
        }),
        downloadPdf() {

            this.transfer = true;
            let url = null;
            if (this.fileNameHash) {
                url = '/api/showFile/' + this.fileNameHash;
            }
            if (this.urlPdfGenerate) {
                url = this.urlPdfGenerate;
            }

            this.showLoading('Descargando documento...');

            axios.get(url, {responseType: 'blob'})
                .then(response => {
                    this.transfer = false;
                    let disposition = response.headers['content-disposition'];
                    var filename = '';
                    if (disposition && disposition.indexOf('inline') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }


                    let blob = new Blob([response.data]);
                    const linkUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = linkUrl;

                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    this.hideLoading();
                })
                .catch(error => {


                    this.hideLoading();
                    this.transfer = false;
                });

        },
        filterSection(data) {
            let filterData = data;
            return filterData;
        },
        checkOnlyOne(onlyOne, data) {

            if (!onlyOne) return true;
            if (!data) return false;

            if (onlyOne === true && data.length >= 1) {
                return false;
            }

            return true;
        },
        showPdf(data) {
            let _id = null;

            if (data && data.file && data.file.fileNameHash) {
                _id = data.file.fileNameHash
            } else {
                _id = data.fileNameHash
            }
            let _self = this;
            let url = '/api/showFile/' + _id;
            axios.get(url, {responseType: 'blob'})
                .then(response => {
                    let blob = new Blob([response.data], {type: response.data.type});
                    this.photoUrl = URL.createObjectURL(blob);
                    _self.showDocument = true
                })
                .catch(error => {

                    this.$store.dispatch('notifications/error', {msg: 'No se puede visualizar'}, {root: true});

                    console.log("error", error);
                });


        },
        closeShowDocument() {
            this.activeShowDocument = false;
        },
        removeDocument(item) {
            this.$confirm('¿Desea eliminar este documento?').then(confirm => {
                this.showLoading = true;
                axios.post('/api/delete-user-document', {
                    file: item.file_id,
                    user: item.user_id,
                }).then(response => {
                    if (response.data.success) {
                        this.removePublicDocument(item);
                        this.$notify.success(response.data.message);
                    } else {
                        this.$notify.error(response.data.message);
                    }
                }).catch(e => {
                    this.$notify.error('No se pudo procesar su solicitud');
                })

                let _aux = [];
                if (this.model) {
                    let _filter = this.userRequest.requirements
                    let _selected = this.userRequest.documents.map(function (e) {
                        return e.cat_requirement_document_id
                    })
                    this.userRequest.requirements = [];

                    _.forEach(_filter, (item) => {
                        item.isActive = true
                    });

                    _.forEach(_filter, (item, key) => {
                        _.forEach(_selected, (item2, key2) => {
                            if (item.id == item2) {
                                item.isActive = false
                            }
                        })
                    })

                    this.userRequest.requirements = _filter;
                }
            }).catch(e => {
                console.log("error ", e)
            }).finally(f => {
                this.showLoading = false
            });

        },
        addFileToRequest(fileInfo) {
            let payload = {
                file_id: fileInfo.id,
                fileName: fileInfo.fileName,
                fileNameHash: fileInfo.fileNameHash,
            };
            this.addUserDoc(payload)
        },

        init() {

            if (this.$route.params.id) {
                //Edit

                return this.fetchSigle({
                    crypt_id: this.$route.params.id
                }).then((res) => {
                    this.userRequest.documents = res.documents
                }).catch((err) => {
                    console.log('err-init-docs', err)
                });

            } else if (this.userId) {
                return this.fetchSigle({
                    crypt_id: this.userId
                }).then((res) => {
                    this.userRequest.documents = res.documents


                }).catch((err) => {
                    console.log('err-init-docs', err)
                });
            } else {
                console.log('else')
            }

        },

        disabledRequirement(document) {
            if (document) {
                let _filter = this.userRequest.requirements
                let _selected = this.userRequest.documents.map(function (e) {
                    return e.cat_requirement_document_id
                })
                this.userRequest.requirements = [];

                _.forEach(_filter, (item) => {
                    item.isActive = true
                });

                _.forEach(_filter, (item, key) => {
                    _.forEach(_selected, (item2, key2) => {
                        if (item.id == item2) {
                            item.isActive = false
                        }
                    })
                })

                this.userRequest.requirements = _filter;

            } else {
                _.forEach(this.userRequest.requirements, (item, key) => {
                    item.isActive = true
                })
            }
        }
    }
};

</script>

